<template>
  <div 
    class="sm-text-copy"
    :class="{
      'copied': justCopied
    }"
    @click.stop="copyText"
  >
    <span>{{text}}</span>
    <include-svg :name="'icon-copy'" />
  </div>
</template>

<script>

export default {
  name: 'text-copy',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      justCopied: false
    }
  },
  methods: {
    copyText() {
      let textarea = document.createElement('textarea');
      textarea.value = this.text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      textarea.remove();

      this.justCopied = true;
      setTimeout(() => {
        this.justCopied = false;
      }, 1000)
    }
  }
}
</script>